import { useCallback } from "react";
import CookieHandler from "utils/cookies";

const iParqueCookiesAcceptanceName = "IPCookies";
const cookieDurationInMinutes = 525600; // 365 days

const useCookies = () => {
  const cookieValue = CookieHandler.get(iParqueCookiesAcceptanceName);

  const handleAcceptCookies = useCallback(() => {
    CookieHandler.set(iParqueCookiesAcceptanceName, true, cookieDurationInMinutes);
  }, []);

  const handleRejectCookies = useCallback(() => {
    CookieHandler.set(iParqueCookiesAcceptanceName, false, cookieDurationInMinutes);
  }, []);

  return {
    isCookiesDecisionMade: cookieValue !== null,
    handleAcceptCookies,
    handleRejectCookies,
  };
};

export default useCookies;
